<template>
  <div id="AddEPaper" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回首頁公告列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
         <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>主旨:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.title"
                  ref="inputData.title"
                  placeholder="請輸入主旨"
                />
              </div>
            </td>
          </tr>
    <tr align="left">
            <td>
              <span class="red_star">＊</span>內容：
              <ckeditor
                :config="config"
                placeholder="請輸入內容"
                v-model="inputData.content"
                ref="inputData.content"
              ></ckeditor>
            </td>
          </tr>



        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="AddEPaper()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";
import Ckeditor from "vue-ckeditor2";
export default {
  name: "AddEPaper",
  components: {
    Ckeditor,
  },
  data() {
    return {
      mode: true,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        title:null,
        content:null,
        showAttached:true,
        Info:[],


      },
      currentPage: 1,
      cid: "",
      pageSize: 10,

      config: {
        toolbar: [
          ["Source", "-", "Preview", "-", "Templates"],
          [
            "Cut",
            "Copy",
            "Paste",
            "PasteText",
            "PasteFromWord",
            "-",
            "Undo",
            "Redo",
          ],
          ["Find", "Replace", "-", "SelectAll", "-", ""],
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "-",
            "CopyFormatting",
            "RemoveFormat",
          ],
          [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language",
          ],
          ["Link", "Unlink", "Anchor"],
          [
            "Image",
            "Table",
            "HorizontalRule",
            "Smiley",
            "SpecialChar",
            "PageBreak",
            "Iframe",
          ],
          ["Styles", "Format", "Font", "FontSize"],
          ["TextColor", "BGColor"],
          ["Maximize", "ShowBlocks"],
          ["About"],
        ],
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {

    empty(str) {
      if (
        typeof str == "undefined" ||
        !str ||
        str.length === 0 ||
        str === "" ||
        !/[^\s]/.test(str) ||
        /^\s*$/.test(str)
      ) {
        return true;
      } else {
        return false;
      }
    },

    checkInput() {
      this.inputFlag = false;
      if (this.empty(this.inputData.title)) {
        alert("請輸入主旨");
        this.$refs["inputData.title"].focus();
        this.inputFlag = true;
        return;
      }

      if (this.empty(this.inputData.content)) {
        alert("請輸入內容");
        this.$refs["inputData.content"].focus();
        this.inputFlag = true;
        return;
      }



    },
    AddEPaper() {
      this.checkInput();
      this.inputData.UpdateUser = this.user.id;
      this.inputData.showAttached=0;
      let vm = this;
      if (vm.inputFlag != true) {
        this.$http
          .put("./WebApi/SportsExcellent/AddEPaper/", this.inputData)
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "增加首頁公告成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,增加首頁公告失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },


    close() {
      this.$emit("hideModal");
    },
  },
  created() {
    console.log("======created AddEPaperView =====");

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
